import { useEffect, useState } from 'react'
import { RecorderPage } from './pages/RecorderPage'
import { SubmissionsPage } from './pages/SubmissionsPage'
import { LoginGate } from './components/auth/LoginGate'
import { AuthCallbackPage } from './pages/AuthCallbackPage'
import { LogoutCompletePage } from './pages/LogoutCompletePage'
import { BottomNav } from './components/BottomNav/BottomNav'

function usePathname(): string {
  const [pathname, setPathname] = useState(() =>
    typeof window === 'undefined' ? '/' : window.location.pathname,
  )

  useEffect(() => {
    const handle = (): void => {
      setPathname(window.location.pathname)
    }
    window.addEventListener('popstate', handle)
    window.addEventListener('app:navigate', handle)
    return () => {
      window.removeEventListener('popstate', handle)
      window.removeEventListener('app:navigate', handle)
    }
  }, [])

  return pathname
}

function App(): JSX.Element {
  const pathname = usePathname()

  if (pathname.startsWith('/auth/callback')) {
    return <AuthCallbackPage />
  }

  if (pathname.startsWith('/logout-complete')) {
    return <LogoutCompletePage />
  }

  // Authenticated app shell: bottom-tab navigation switches between the recorder
  // and the submissions history; both render above a shared BottomNav.
  const page = pathname.startsWith('/submissions') ? <SubmissionsPage /> : <RecorderPage />

  return (
    <>
      <LoginGate>
        {page}
        <BottomNav pathname={pathname} />
      </LoginGate>
    </>
  )
}

export default App
